{
    "ai_modal_title_1": "Tingkatkan teks Anda dengan AI",
    "ai_modal_title_2": "Menghasilkan teks baru menggunakan AI",
    "ai_description": "Gunakan alat bantu pembuatan konten AI untuk menyempurnakan teks Anda.",
    "ai_learn_more": "Pelajari lebih lanjut",
    "ai_copy_text": "Salin teks",
    "ai_describe_your_text": "Jelaskan tentang apa isi teks Anda",
    "ai_describe_your_text_example": "Contoh: deskripsi singkat untuk toko online yang menjual sabun buatan tangan",
    "ai_new_request": "Buat permintaan baru",
    "ai_create_text": "Menghasilkan teks",
    "ai_apply_text": "Menerapkan teks",
    "ai_try_one_more": "Coba lagi",
    "ai_correct_errors": "Memperbaiki kesalahan",
    "ai_make_longer": "Perpanjang",
    "ai_make_shorter": "Mempersingkat",
    "ai_simplify": "Menyederhanakan",
    "ai_business_tone": "Formal",
    "ai_ceremonial_tone": "Meriah",
    "ai_fun_tone": "Menyenangkan",
    "ai_friendly_tone": "Ramah",
    "ai_change_tone": "Mengubah nada suara",
    "ai_improve_text": "Memperbaiki teks",
    "ai_words_number": "Jumlah kata:",
    "ai_translate": "Menerjemahkan",
    "ai_translate_to_ru": "Terjemahkan ke bahasa Rusia",
    "ai_translate_to_en": "Terjemahkan ke bahasa Inggris",
    "ai_add_creativity": "Menambah kreativitas",
    "ai_text_too_large": "Teks Anda terlalu panjang untuk menggunakan AI. Buat lebih pendek atau buat teks baru tentang topik yang diperlukan dengan bantuan AI.",
    "ai_translate_to_ua": "Terjemahkan ke bahasa Ukraina",
    "ai_translate_to_es": "Terjemahkan ke bahasa Spanyol",
    "ai_translate_to_pt": "Terjemahkan ke bahasa Portugis",
    "ai_translate_to_tr": "Terjemahkan ke bahasa Turki",
    "ai_translate_to_fr": "Terjemahkan ke bahasa Prancis",
    "ai_translate_to_de": "Terjemahkan ke bahasa Jerman",
    "ai_translate_to_it": "Terjemahkan ke bahasa Italia",
    "ai_translate_to_pl": "Terjemahkan ke bahasa Polandia",
    "ai_free_request_error": "Permintaan gratis sudah berakhir",
    "ai_free_request_number": "Nomor permintaan: {{ FREE_KEY }} / {{ FREE_KEY_LIMIT }}",
    "ai_request_limit_info": "Anda dapat menggunakan hingga 200 permintaan alat AI gratis. Untuk membuat lebih banyak permintaan, aktifkan kunci API Anda ke penyedia AI di pengaturan akun Anda.",
    "cancel": "Batal",
    "gpt_error_quota": "Anda telah mencapai batas permintaan API Anda. Untuk terus menggunakan alat bantu AI, periksa batas Anda saat ini atau tambahkan dana ke saldo kredit di pengaturan akun OpenAI.",
    "ai_generated_disclaimer": "Anda bertanggung jawab atas teks yang dihasilkan. Tinjau sebelum dipublikasikan."
}
